import { Stack } from '@mui/material';
import { Button } from '@/components/ui/button';
import { WeekSwitch } from '@/components/common/WeekSwitch';
import { ViewSwitch } from './components/view-switch';
import { BoardViewMode } from '../../config';
import { Icon } from '@/units/index';
import TextInput from '@/components/ui/text-input';
import { useBoardContext } from '../../hooks/useBoardContext';
import { AddNoteButton } from './components/add-note-button';
import { Filters } from './components/filters';
import { FAIcon } from '@packages/ui-components';

export function BoardControls() {
  const {
    isBacklogOpen,
    toggleBacklogOpen,
    setViewMode,
    viewMode,
    setWeekRange,
    weekRange,
    boardSearch,
    setBoardSearch,
  } = useBoardContext();

  const handleViewModeChange = (mode: BoardViewMode) => {
    setViewMode(mode);
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        height: '84px',
        px: '18px',
        containerType: 'inline-size',
        width: '100%',
        minHeight: '84px',
      }}
    >
      <Stack direction="row" gap="10px">
        <ViewSwitch mode={viewMode} onChange={handleViewModeChange} />
        <AddNoteButton />
      </Stack>

      <Stack direction="row" gap="10px">
        <Button
          sx={{ px: '18px', minWidth: '0', height: '44px' }}
          onClick={() => setWeekRange(WeekSwitch.getWeekRange())}
        >
          Today
        </Button>
        <WeekSwitch
          value={weekRange}
          onDateChange={setWeekRange}
          sx={{
            width: 'fit-content',
            '@container board-content (max-width: 1280px)': {
              px: '4px',
            },
          }}
          textProps={{
            sx: {
              color: WeekSwitch.isInDateRange(weekRange) ? '#2055FF' : '#344054',
              width: '160px',
              whiteSpace: 'nowrap',
              flex: '0 0 auto',
            },
          }}
        />
      </Stack>

      <Stack direction="row" gap="10px">
        <TextInput
          placeholder="Search..."
          startIcon={<FAIcon icon="faMagnifyingGlass" size={18} />}
          containerProps={{
            sx: {
              width: '260px',
              '@container board-content (max-width: 1280px)': {
                width: '224px',
              },
            },
          }}
          onChange={(e) => setBoardSearch(e.target.value)}
          value={boardSearch}
        />

        <Filters />

        <Button
          onClick={() => toggleBacklogOpen()}
          sx={{
            width: '44px',
            height: '44px',
            minWidth: '44px',
            maxWidth: '44px',
            padding: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '8px',
          }}
        >
          {isBacklogOpen ? (
            <Icon.DrawerOpened sx={{ width: '20px !important', height: '20px !important' }} />
          ) : (
            <Icon.DrawerClosed sx={{ width: '20px !important', height: '20px !important' }} />
          )}
        </Button>
      </Stack>
    </Stack>
  );
}
